import React, { PureComponent } from 'react';

const styles = {
  'disclaimerTooltip': 'email-signup-tooltip',
  'tooltipContainer': 'email-signup-tooltip__container',
  'tooltipButtonText': 'email-signup-tooltip__buttonText',
  'tooltipTipTitle': 'email-signup-tooltip__tipTitle',
  'tooltipInfoIcon': 'email-signup-tooltip__disclaimer-info-icon',
};

export default class Tooltip extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      contentOpen: false,
    };
  }

  render() {
    const { contentOpen } = this.state;

    const openTooltip = () => {
      this.setState({ contentOpen: true });
    };

    const closeTooltip = () => {
      this.setState({ contentOpen: false });
    };

    const onButtonTouchStart = () => {
      this.setState({
        scrollStartPosition: window.scrollY,
      });
    };

    const onButtonTouchEnd = evt => {
      evt.preventDefault();
      const scrollEndPosition = window.scrollY;

      // check intended button click
      if (!(scrollEndPosition > this.state.scrollStartPosition + 5)) {
        // toggle close
        if (this.state.contentOpen) {
          closeTooltip();
          return;
        }

        openTooltip();
      }
    };

    const onButtonKeyUp = event => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        if (this.state.contentOpen) {
          closeTooltip();
          return;
        }

        openTooltip();
      }
    };

    const onMouseOver = () => {
      const isTouch = 'ontouchstart' in window;
      if (isTouch) return;
      openTooltip();
    };

    return (
      <div className={styles.disclaimerTooltip}>
        <div className={styles.tooltipContainer} onMouseLeave={closeTooltip}>
          <button type="button"
            onTouchStart={onButtonTouchStart}
            onTouchEnd={onButtonTouchEnd}
            onKeyUp={onButtonKeyUp}
            onMouseOver={onMouseOver}
            onFocus={openTooltip}
            className={styles.tooltipButtonText}>
            <div>
              <span className={styles.tooltipTipTitle}>What will I receive?</span>
            </div>
          </button>
          {contentOpen && (
            <div role="alert" className="tooltip-popover tooltip-popover-containerBottom tooltip-popover-containerLeft">
              <div className="arrow"></div>
              <div className="inner">
                <div className="tooltip-overlay" onTouchStart={closeTooltip}></div>
                <p>
                  We&#39;ll send you updates on new arrivals, inspiration, offers &amp; promotional events.
                </p>
              </div>
            </div>
          )}
        </div>
        <svg className={styles.tooltipInfoIcon} viewBox="0 0 24 24" width="24" height="24" fill="currentcolor">
          <path d="M12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 C5.925,1 1,5.925 1,12 C1,18.075 5.925,23 12,23 Z M12,24 C5.373,24 0,18.627 0,12 C0,5.373 5.373,0 12,0 C18.627,0 24,5.373 24,12 C24,18.627 18.627,24 12,24 Z M12,8 C11.4477153,8 11,7.55228475 11,7 C11,6.44771525 11.4477153,6 12,6 C12.5522847,6 13,6.44771525 13,7 C13,7.55228475 12.5522847,8 12,8 Z M11.5,11 L12.5,11 L12.5,19 L11.5,19 L11.5,11 Z"></path>
        </svg>
      </div>
    );
  }
}
